// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f8490619","138":"8c21fafc","165":"f4b86640","270":"b46117f4","609":"c379a74f","845":"fe57ce22","983":"d83106b0"}[chunkId] + ".chunk.js";
};